export type Theme = 'light' | 'dark';

export const THEME_STORAGE_KEY = 'siv-theme';

/**
 * Light is the product default. A stored choice always wins; only a visitor who
 * has never chosen falls back to their OS preference.
 */
export function resolveInitialTheme(): Theme {
  if (typeof window === 'undefined') return 'light';

  try {
    const stored = window.localStorage.getItem(THEME_STORAGE_KEY);
    if (stored === 'light' || stored === 'dark') return stored;
  } catch {
    // Private mode or blocked storage — fall through to the media query.
  }

  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

/** Single place that mutates the document, so the DOM can never disagree with state. */
export function applyTheme(theme: Theme) {
  const root = document.documentElement;
  root.dataset.theme = theme;
  root.style.colorScheme = theme;

  document.head
    .querySelector('meta[name="theme-color"]')
    ?.setAttribute('content', theme === 'dark' ? '#070E1A' : '#FFFFFF');
}

export function storeTheme(theme: Theme) {
  try {
    window.localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch {
    // Not being able to remember the choice is not worth breaking the toggle.
  }
}
